export default "__VITE_ASSET__BVFe_6f9__"